// extracted by mini-css-extract-plugin
export default {"benchmarksContainer":"benchmarksContainer__WNPpg","benchmarksLink":"benchmarksLink__s__pj","tag":"tag__Gwi53","seeMore":"seeMore__JKFpT"};